import { ACCEPTED_CARDS, getIntegerCharacter } from './regex.utils'

const FOUR_DIGIT_CVV_REGEX = /^\d{4}$/
const THREEE_DIGIT_CVV_REGEX = /^\d{3}$/

// Validate card number using Luhn Algorithm
export const isValidCard = (value) => {
	const formattedValue = getIntegerCharacter(value)
	let sum = 0
	let shouldDouble = false

	// loop through value starting at the rightmost side of card
	for (let i = formattedValue && formattedValue.length - 1; i >= 0; i--) {
		let digit = parseInt(formattedValue.charAt(i))
		if (shouldDouble) {
			if ((digit *= 2) > 9) digit -= 9
		}
		sum += digit
		shouldDouble = !shouldDouble
	}
	return sum % 10 === 0
}

export const getCardVendorName = (value) => {
	const formattedValue = getIntegerCharacter(value)
	let cardName = ''
	Object.keys(ACCEPTED_CARDS).forEach((key) => {
		const regex = ACCEPTED_CARDS[key]
		if (regex.test(formattedValue)) {
			cardName = key
		}
	})
	return cardName
}

export const isValidCVV = (card, CVV) => {
	const formattedCard = card && getIntegerCharacter(card)
	const formattedCVV = CVV && getIntegerCharacter(CVV)
	return ACCEPTED_CARDS.American_Express.test(formattedCard)
		? FOUR_DIGIT_CVV_REGEX.test(CVV)
		: THREEE_DIGIT_CVV_REGEX.test(formattedCVV)
}
